import { HttpClient } from '../../httpClient'
import {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

export function updateBoardObjectCollection(
  params: OpalApiRequestParams<'UpdateBoardObjectCollectionV3'>,
  requestBody: OpalApiRequestBody<'UpdateBoardObjectCollectionV3'>
): Promise<OpalApiResponseDocument<'UpdateBoardObjectCollectionV3', 200>> {
  const url = new URL(
    `/board_object_collections/v3/${params.path.board_object_collection_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
